// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "._2nTkW9l0WVMbRDgT_Gww7_ {\n  margin: auto;\n  margin-bottom: 30vw;\n}\n  \n  @media screen and (min-aspect-ratio: 3/2){._2nTkW9l0WVMbRDgT_Gww7_ {\n      width: 75%\n}\n  }", "",{"version":3,"sources":["SessionCvsDGraph.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;AAKrB;;EAHE,0CAJF;MAKM;AAEN;EADE","file":"SessionCvsDGraph.css","sourcesContent":[".SessionCvsDGraph {\n  margin: auto;\n  margin-bottom: 30vw;\n  \n  @media screen and (min-aspect-ratio: 3/2){\n      width: 75%;\n  }\n}"]}]);
// Exports
exports.locals = {
	"SessionCvsDGraph": "_2nTkW9l0WVMbRDgT_Gww7_"
};
module.exports = exports;
